export default defineNuxtRouteMiddleware(async (to) => {
  try {
    await useRequestFetch()('/api/proposal-admin/access')
  } catch (error: any) {
    const status = error?.statusCode || error?.status || error?.data?.statusCode
    if (status === 401)
      return navigateTo({ path: '/login', query: { redirect: to.fullPath } })
    return abortNavigation(
      createError({
        statusCode: status === 403 ? 403 : 503,
        statusMessage:
          status === 403
            ? 'System admin access is required.'
            : 'Unable to check proposal access. Please try again.',
        data: { proposalAccessDenied: status === 403 },
      }),
    )
  }
})
